const references = {}

export default references
